import React from 'react';
import PickupPoint from './PickupPoint.jsx';
import { Badge, Text, Link, VStack } from "@postenbring/hedwig-react";

const HitAddress = ({hit, hitIndex, localization}) => (
    <VStack gap="8" align="flex-start">
        <Badge size="smaller">{localization.address.categoryLabel}</Badge>
        <Text variant='h3' as="h2">{hit.heading}</Text>
        <span>{localization.address.houseNumber}:</span>
        {hit.house_number_letter_list ? hit.house_number_letter_list.map((number, index) => <React.Fragment key={index}>{!!index && ", "}{number}</React.Fragment>) : ''}
        {hit.pickupPoint && (
            <>
                <PickupPoint pickupPoint={hit.pickupPoint} localization={localization}/>
                <Link href={hit.absoluteUrl} aria-describedby={"hit-" + hitIndex}>{localization.address.linkLabel}</Link>
            </>
        )}
    </VStack>
);

export default HitAddress;
